import React, { useContext } from 'react'
import { isMobileContext } from '../context/isMobileContext';
import { motion } from 'framer-motion'
const PartnerCard = ({ img, name, index }) => {
    const { isMobile } = useContext(isMobileContext);
    return (
        <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ ease: "easeInOut", delay: isMobile ? parseFloat(0.1 + index * 0.05) : parseFloat(0.15 + index / 20), duration: 0.15}}
        className='partner-card'>
            <div className='circle'>
                <img
                    className={`${index === 1 && "custom-image"}
                    ${index === 0 && "custom1-image"}
                    ${index === 3 && "custom1-image"}
                    ${index === 4 && "custom1-image"}
                    ${index === 5 && "custom1-image"}
                    ${index === 12 && "custom1-image"}
                    ${index === 13 && "custom1-image"}
                    `}
                    src={process.env.PUBLIC_URL + img} alt={name} />
            </div>
            <div className='text'>{name}</div>
        </motion.div>
    )
}

export default PartnerCard